import { render, staticRenderFns } from "./recordBusinessDrawer.vue?vue&type=template&id=3f52e608&scoped=true&"
import script from "./recordBusinessDrawer.vue?vue&type=script&lang=js&"
export * from "./recordBusinessDrawer.vue?vue&type=script&lang=js&"
import style0 from "./recordBusinessDrawer.vue?vue&type=style&index=0&id=3f52e608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f52e608",
  null
  
)

export default component.exports